import React, { useRef } from 'react';
import { makeStyles, Theme } from '@lifeomic/chroma-react/styles';
import { useMount, useUnmount } from 'react-use';

export const useStyles = makeStyles((_theme: Theme) => ({
  root: {},
}));

export type PreventOutsideRedirectOwnProps = {};

export type PreventOutsideRedirectProps = PreventOutsideRedirectOwnProps;

const handleRedirect = () => {
  return '';
};

const WarnOnRedirect: React.FC<PreventOutsideRedirectProps> = () => {
  const originalHandler = useRef(null);
  useMount(() => {
    // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
    originalHandler.current = window.onbeforeunload;
    window.onbeforeunload = handleRedirect;
  });
  useUnmount(() => {
    window.onbeforeunload = originalHandler.current;
  });

  return null;
};

export default React.memo(WarnOnRedirect);
